'use client'

import { H1 } from '../ui/heading'
import { CategoryPill, Pill } from './pill'
import { Book, Podcast as PodcastIcon } from 'lucide-react'
import { usePathname, useParams } from 'next/navigation'
import { Category } from '~/lib/sanity.queries'

type Props = {
  categories: Category[]
}

export function BlogCategorySelector(props: Props) {
  const pathname = usePathname()
  const params = useParams()
  return (
    <div className="mt-20 grid-container container mb-20">
      <hgroup className="flex flex-col gap-4 text-center col-span-full">
        <H1>The Happitu Blog</H1>
        <p>
          A collection of thoughts, how-tos, and guides to help you deliver <br /> happy
          experiences.
        </p>
      </hgroup>
      <hr className="col-span-full" />
      <div className="col-span-2">Filters</div>
      <div className="col-span-3 flex flex-wrap items-start gap-2">
        <Pill
          href={'/learn/podcast' === pathname ? '/learn' : '/learn/podcast'}
          active={'/learn/podcast' === pathname}
        >
          <PodcastIcon className="h-4" />
          Podcast
        </Pill>
        <Pill
          href={'/learn/blog' === pathname ? '/learn' : '/learn/blog'}
          active={'/learn/blog' === pathname}
        >
          <Book className="h-4" />
          Articles
        </Pill>
      </div>
      <div className="col-span-7 flex flex-wrap gap-2">
        {props.categories.map((category, key) => {
          return (
            <CategoryPill
              key={key}
              slug={category.slug}
              title={category.title}
              active={params.category === category.slug.current}
            />
          )
        })}
      </div>
      <hr className="col-span-full" />
    </div>
  )
}
